import { FormattedMessage } from 'react-intl';
import { faShieldKeyhole } from '@fortawesome/pro-solid-svg-icons/faShieldKeyhole';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn, FlexRow, Gap } from 'ui-components/components/flex';

import { messages } from '../../messages';
import style from '../../app-store-install-page.module.less';

type ScopesCardProps = {
  scopes: string[];
};

export const ScopesCard = ({ scopes }: ScopesCardProps) => {
  if (scopes.length === 0) {
    return (
      <Text className={style.dimText} textType={TextType.Description} value={<FormattedMessage {...messages.noPermissionsRequired} />} />
    );
  }

  return (
    <div className={style.scopesCard}>
      <FlexColumn gap={Gap.Space12}>
        <FlexRow gap={Gap.Space8}>
          <FontAwesomeIcon icon={faShieldKeyhole} />
          <Text isBold textType={TextType.Label} value={<FormattedMessage {...messages.permissionsHeading} />} />
        </FlexRow>
        <FlexColumn gap={Gap.Space4}>
          {scopes.map((scope) => (
            <Text key={scope} className={style.scopeItem} textType={TextType.Description} value={scope} />
          ))}
        </FlexColumn>
      </FlexColumn>
    </div>
  );
};
